import Select from "react-select";
import { TEt3Picker, TEt3PickerOption } from "../../../TypesNEW";
import ET3Div from "../../et3-div";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";
import Et3Text from "../../et3-text";
import { isDefinedString } from "et3-type-guards";
import { pickerEmptyValueReducer } from "../../../helpers/et3-picker-data-helper";
import {
  FIELD_BORDER,
  FIELD_GAP,
  FIELD_HEIGHT,
  FIELD_INPUT_FONT_SIZE,
  FIELD_LABEL_FONT_SIZE,
  FIELD_LABEL_LETTER_SPACING,
  FIELD_LABEL_HEIGHT,
  FIELD_PADDING_X,
  FIELD_RADIUS,
  FIELD_SHADOW,
  FIELD_SHADOW_FOCUS,
  FIELD_TRANSITION
} from "../et3-text-input/text-input-constants";
import {
  PICKER_BADGE_FONT_SIZE,
  PICKER_BADGE_HEIGHT,
  PICKER_BADGE_RADIUS,
  PICKER_BADGE_WIDTH,
  PICKER_BLOCK_HEIGHT,
  PICKER_INDICATOR_SIZE,
  PICKER_MENU_MAX_HEIGHT,
  PICKER_MENU_OFFSET,
  PICKER_MENU_SHADOW,
  PICKER_OPTION_FONT_SIZE,
  PICKER_OPTION_HOVER,
  PICKER_OPTION_MIN_HEIGHT,
  PICKER_OPTION_PADDING
} from "./picker-constants";

const Et3Picker = withLiteObserverAndTheme<TEt3Picker>((props) => {
  const {
    label,
    options,
    value,
    theme,
    isMultiple,
    style,
    containerStyle,
    width = 280,
    onChoose
  } = props;
  const { colors, unitX, unitY, getFontType, getFontSize } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      fDirection="column"
      justifyContent="center"
      alignItems="center"
      withShadow={false}
      width={width}
      height={PICKER_BLOCK_HEIGHT}
      color={colors.all.transparent}
      style={style}
      onClick={() => {}}
    >
      {isDefinedString(label) ? (
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          fDirection="row"
          justifyContent="flex-start"
          alignItems="center"
          withShadow={false}
          width={width}
          height={FIELD_LABEL_HEIGHT}
          color={colors.all.transparent}
          style={{}}
          onClick={() => {}}
        >
          <Et3Text
            fontFamily={"MEDIUM"}
            fontSize={FIELD_LABEL_FONT_SIZE}
            text={label}
            isSpan={false}
            color={colors.all.maastrichtBlue}
            style={{
              margin: 0,
              textAlign: "left",
              letterSpacing: FIELD_LABEL_LETTER_SPACING * unitX
            }}
          />
        </ET3Div>
      ) : null}

      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={width}
        height={FIELD_HEIGHT}
        fDirection="row"
        alignItems="center"
        justifyContent="flex-start"
        color={colors.all.transparent}
        style={{ width: "100%", minWidth: 0 }}
        onClick={() => {}}
      >
        <Select
          //if isMultiple is true then value should be array else will get an error
          value={pickerEmptyValueReducer(value)}
          placeholder={
            <Et3Text
              fontFamily={"LIGHT"}
              fontSize={0}
              isSpan={false}
              text={""}
              style={{}}
              color={""}
            />
          }
          onChange={(newValue: TEt3PickerOption) => {
            onChoose(pickerEmptyValueReducer(newValue));
          }}
          options={options}
          styles={{
            option: (provided, state) => ({
              ...provided,
              fontSize: getFontSize(PICKER_OPTION_FONT_SIZE),
              fontFamily: getFontType("MEDIUM"),
              color: colors.all.maastrichtBlue,
              backgroundColor: state.isFocused
                ? PICKER_OPTION_HOVER
                : colors.all.white,
              minHeight: PICKER_OPTION_MIN_HEIGHT * unitY,
              paddingLeft: FIELD_PADDING_X * unitX,
              paddingRight: FIELD_PADDING_X * unitX,
              cursor: "pointer",
              overflowWrap: "break-word",
              overflow: "hidden"
            }),

            singleValue: (provided) => ({
              ...provided,
              textAlign: "left",
              color: colors.all.maastrichtBlue,
              fontFamily: getFontType("MEDIUM"),
              fontSize: getFontSize(FIELD_INPUT_FONT_SIZE)
            }),
            dropdownIndicator: (base, state) => ({
              ...base,
              padding: 0,
              width: PICKER_INDICATOR_SIZE * unitX,
              height: PICKER_INDICATOR_SIZE * unitY,
              color: state.isFocused ? colors.all.bondiBlue : colors.all.gray,
              transition: FIELD_TRANSITION
            }),
            indicatorSeparator: () => ({
              display: "none"
            }),
            indicatorsContainer: () => ({
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              pointerEvents: "none"
            }),
            valueContainer: (provided) => ({
              ...provided,
              padding: 0,
              minWidth: 0
            }),
            control: (_base, state) => ({
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              boxSizing: "border-box",
              width: "100%",
              minWidth: 0,
              minHeight: FIELD_HEIGHT * unitY,
              backgroundColor: colors.all.white,
              borderRadius: FIELD_RADIUS * unitX,
              border: state.isFocused
                ? `1px solid ${colors.all.bondiBlue}`
                : FIELD_BORDER,
              boxShadow: state.isFocused ? FIELD_SHADOW_FOCUS : FIELD_SHADOW,
              transition: FIELD_TRANSITION,
              paddingLeft: FIELD_PADDING_X * unitX,
              paddingRight: FIELD_PADDING_X * unitX,
              gap: FIELD_GAP * unitX,
              cursor: "pointer"
            }),
            clearIndicator: () => ({
              display: "none"
            }),
            menuList: () => ({
              overflow: "auto",
              maxHeight: PICKER_MENU_MAX_HEIGHT * unitY,
              marginBottom: 0,
              paddingTop: 0,
              paddingBottom: 0
            }),
            // flagged description used to push the page height to include the select menu
            menu: (provided) => ({
              ...provided,
              position: "relative",
              marginTop: PICKER_MENU_OFFSET * unitY,
              marginBottom: 0,
              border: FIELD_BORDER,
              borderRadius: FIELD_RADIUS * unitX,
              boxShadow: PICKER_MENU_SHADOW,
              overflow: "hidden"
            }),
            container: (provided) => ({
              width: "100%",
              ...provided,
              ...containerStyle
            })
          }}
          isMulti={isMultiple}
          components={
            options.some((option) => option.badge)
              ? {
                  Option: ({ children, ...props }) => (
                    <div {...props.innerProps}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          backgroundColor: props.isFocused
                            ? PICKER_OPTION_HOVER
                            : colors.all.transparent,
                          padding: PICKER_OPTION_PADDING * unitX
                        }}
                      >
                        <span>{props.data.label}</span>
                        {props.data.badge > 0 && (
                          <div
                            style={{
                              backgroundColor: colors.all.red,
                              color: "white",
                              borderRadius: PICKER_BADGE_RADIUS * unitX,
                              width: PICKER_BADGE_WIDTH * unitX,
                              height: PICKER_BADGE_HEIGHT * unitY,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: getFontSize(PICKER_BADGE_FONT_SIZE),
                              fontWeight: "bold"
                            }}
                          >
                            {props.data.badge}
                          </div>
                        )}
                      </div>
                    </div>
                  )
                }
              : undefined
          }
        />
      </ET3Div>
    </ET3Div>
  );
});
export default Et3Picker;
